import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../@core/auth/auth.service';

import { DEMO_CREWS, Fp_Crew } from '../../models/fp-crew';

@Injectable({
  providedIn: 'root'
})
export class FpCrewService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getCrews(includeInactive = false): Observable<Fp_Crew[]> {

    if (environment.isMockEnabled) {
      return of(DEMO_CREWS);
    }
    return this.httpClient.get<Fp_Crew[]>(`${this.basePath}/api/FirmanPollen/FpCrew`,
      { params: includeInactive ? { IncludeInactive: 'true' } : {} });
  }

  public putCrew(crew: Fp_Crew): Observable<Fp_Crew> {
    return this.httpClient.put<Fp_Crew>(`${this.basePath}/api/FirmanPollen/FpCrew/${crew.id}`, crew);
  }


  public postCrew(crew: Fp_Crew): Observable<Fp_Crew> {

    if (environment.isMockEnabled) {
      return of(crew);
    }

    return this.httpClient.post<Fp_Crew>(`${this.basePath}/api/FirmanPollen/FpCrew`,
      crew);
  }

  public deleteCrew(id: number): Observable<Fp_Crew> {
    let queryParameters = new HttpParams();
    queryParameters = queryParameters.set('setInactive', "false");

    const httpHeaderAcceptSelected: string | undefined = 'application/json';

    return this.httpClient.delete<Fp_Crew>(`${this.basePath}/api/FirmanPollen/FpCrew/${id}`,
      {
        params: queryParameters,
      }
    );
  }
}


